export var customTexts = function customTexts(strictLocalize) {
  return {
    actionPaymentCompleted: strictLocalize({
      id: "I8qY2N",
      defaultMessage: [{
        "type": 0,
        "value": "Payment completed"
      }]
    }),
    actionPaymentError: strictLocalize({
      id: "ZAyV+v",
      defaultMessage: [{
        "type": 0,
        "value": "An error occurred while processing the card. Please try again or use a different card."
      }]
    }),
    actionPostbackError: strictLocalize({
      id: "4nX2E/",
      defaultMessage: [{
        "type": 0,
        "value": "An error occurred while processing your action. Please try again. "
      }]
    }),
    clickToRetry: strictLocalize({
      id: "VtFpKp",
      defaultMessage: [{
        "type": 0,
        "value": "Message not delivered. Refresh browser to retry."
      }]
    }),
    clickToRetryForm: strictLocalize({
      id: "u15Uck",
      defaultMessage: [{
        "type": 0,
        "value": "Form not submitted. Click anywhere on the form to retry."
      }]
    }),
    connectNotificationText: strictLocalize({
      id: "FNME6m",
      defaultMessage: [{
        "type": 0,
        "value": "Sync your conversation and continue messaging us through your favourite app."
      }]
    }),
    connectNotificationSingleText: strictLocalize({
      id: "SQ7ADB",
      defaultMessage: [{
        "type": 0,
        "value": "Be notified when you get a reply."
      }]
    }),
    conversationListHeaderText: strictLocalize({
      id: "8mVcn4",
      defaultMessage: [{
        "type": 0,
        "value": "My conversations"
      }]
    }),
    conversationListPreviewAnonymousText: strictLocalize({
      id: "d5Sp/y",
      defaultMessage: [{
        "type": 0,
        "value": "Someone"
      }]
    }),
    conversationListPreviewCarouselText: strictLocalize({
      id: "BNBuTY",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " sent a message"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFileText: strictLocalize({
      id: "Um9Kpq",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " sent a file"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFormText: strictLocalize({
      id: "1fsFts",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " sent a form"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFormResponseText: strictLocalize({
      id: "OMXLSv",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " filled in a form"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewImageText: strictLocalize({
      id: "8nkquk",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " sent an image"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewLocationRequestText: strictLocalize({
      id: "p/7Vs+",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " sent a location request"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewUserText: strictLocalize({
      id: "5p2Qih",
      defaultMessage: [{
        "type": 0,
        "value": "You"
      }]
    }),
    conversationListRelativeTimeJustNow: strictLocalize({
      id: "72Tqww",
      defaultMessage: [{
        "type": 0,
        "value": "Just now"
      }]
    }),
    conversationListRelativeTimeMinute: strictLocalize({
      id: "IjmHdR",
      defaultMessage: [{
        "type": 0,
        "value": "1 minute ago"
      }]
    }),
    conversationListRelativeTimeMinutes: strictLocalize({
      id: "hBcPit",
      defaultMessage: [{
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " minutes ago"
      }]
    }, {
      valueTime: "{value}"
    }),
    conversationListRelativeTimeHour: strictLocalize({
      id: "GZ73D9",
      defaultMessage: [{
        "type": 0,
        "value": "1 hour ago"
      }]
    }),
    conversationListRelativeTimeHours: strictLocalize({
      id: "D1AceC",
      defaultMessage: [{
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " hours ago"
      }]
    }, {
      valueTime: "{value}"
    }),
    conversationListRelativeTimeYesterday: strictLocalize({
      id: "9Cwjfp",
      defaultMessage: [{
        "type": 0,
        "value": "Yesterday"
      }]
    }),
    couldNotConnect: strictLocalize({
      id: "UjUBuG",
      defaultMessage: [{
        "type": 0,
        "value": "Offline. You will not receive messages."
      }]
    }),
    couldNotConnectRetry: strictLocalize({
      id: "kXGiZU",
      defaultMessage: [{
        "type": 0,
        "value": "Reconnecting..."
      }]
    }),
    couldNotConnectRetrySuccess: strictLocalize({
      id: "WxKYO6",
      defaultMessage: [{
        "type": 0,
        "value": "You’re back online!"
      }]
    }),
    couldNotLoadConversations: strictLocalize({
      id: "NT287R",
      defaultMessage: [{
        "type": 0,
        "value": "Couldn’t load conversations."
      }]
    }),
    emailChangeAddress: strictLocalize({
      id: "lMdZaG",
      defaultMessage: [{
        "type": 0,
        "value": "Change my email"
      }]
    }),
    emailDescription: strictLocalize({
      id: "FtDtu+",
      defaultMessage: [{
        "type": 0,
        "value": "To be notified by email when you get a reply, enter your email address."
      }]
    }),
    emailFieldLabel: strictLocalize({
      id: "3bcv4v",
      defaultMessage: [{
        "type": 0,
        "value": "Email"
      }]
    }),
    emailFieldPlaceholder: strictLocalize({
      id: "2L9ili",
      defaultMessage: [{
        "type": 0,
        "value": "Your email address"
      }]
    }),
    emailFormButton: strictLocalize({
      id: "OCxMgt",
      defaultMessage: [{
        "type": 0,
        "value": "Submit"
      }]
    }),
    emailLinkingErrorMessage: strictLocalize({
      id: "pJuL3D",
      defaultMessage: [{
        "type": 0,
        "value": "Please submit a valid email address."
      }]
    }),
    fetchHistory: strictLocalize({
      id: "n288kk",
      defaultMessage: [{
        "type": 0,
        "value": "Load more"
      }]
    }),
    fetchingHistory: strictLocalize({
      id: "p0LVGs",
      defaultMessage: [{
        "type": 0,
        "value": "Retrieving history..."
      }]
    }),
    fileTooLargeError: strictLocalize({
      id: "Yl3C6g",
      defaultMessage: [{
        "type": 0,
        "value": "Max. file size limit exceeded ("
      }, {
        "type": 1,
        "value": "sizeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      sizeNumber: "{size}"
    }),
    fileTypeError: strictLocalize({
      id: "GpVgdA",
      defaultMessage: [{
        "type": 0,
        "value": "Unsupported file type."
      }]
    }),
    formErrorEntryRequired: strictLocalize({
      id: "U6eN9Z",
      defaultMessage: [{
        "type": 0,
        "value": "This entry is required"
      }]
    }),
    formErrorInvalidEmail: strictLocalize({
      id: "CfLksk",
      defaultMessage: [{
        "type": 0,
        "value": "Email is invalid"
      }]
    }),
    formErrorNoLongerThan: strictLocalize({
      id: "gZ/mqf",
      defaultMessage: [{
        "type": 0,
        "value": "Must contain no more than ("
      }, {
        "type": 1,
        "value": "charactersNumber"
      }, {
        "type": 0,
        "value": ") characters"
      }]
    }, {
      charactersNumber: "{characters}"
    }),
    formErrorNoShorterThan: strictLocalize({
      id: "6UhNRq",
      defaultMessage: [{
        "type": 0,
        "value": "Must contain at least ("
      }, {
        "type": 1,
        "value": "charactersNumber"
      }, {
        "type": 0,
        "value": ") characters"
      }]
    }, {
      charactersNumber: "{characters}"
    }),
    formErrorUnknown: strictLocalize({
      id: "uHmA0t",
      defaultMessage: [{
        "type": 0,
        "value": "This doesn’t look quite right"
      }]
    }),
    formFieldSelectPlaceholderFallback: strictLocalize({
      id: "IqApqR",
      defaultMessage: [{
        "type": 0,
        "value": "Choose one..."
      }]
    }),
    frontendEmailChannelDescription: strictLocalize({
      id: "UrftLW",
      defaultMessage: [{
        "type": 0,
        "value": "To talk to us using email, just send a message to our email address and we’ll reply shortly:"
      }]
    }),
    headerText: strictLocalize({
      id: "LzUo5v",
      defaultMessage: [{
        "type": 0,
        "value": "How can we help?"
      }]
    }),
    imageClickToReload: strictLocalize({
      id: "MYu9Dn",
      defaultMessage: [{
        "type": 0,
        "value": "Click to reload image."
      }]
    }),
    imageClickToView: strictLocalize({
      id: "iDcbK1",
      defaultMessage: [{
        "type": 0,
        "value": "Click to view "
      }, {
        "type": 1,
        "value": "sizeNumber"
      }, {
        "type": 0,
        "value": " image."
      }]
    }, {
      sizeNumber: "{size}"
    }),
    imagePreviewNotAvailable: strictLocalize({
      id: "7xJ0Oe",
      defaultMessage: [{
        "type": 0,
        "value": "Preview not available."
      }]
    }),
    inputPlaceholder: strictLocalize({
      id: "Qz0IJv",
      defaultMessage: [{
        "type": 0,
        "value": "Type a message..."
      }]
    }),
    inputPlaceholderBlocked: strictLocalize({
      id: "lKCy+g",
      defaultMessage: [{
        "type": 0,
        "value": "Complete the form above..."
      }]
    }),
    introAppText: strictLocalize({
      id: "WwisEh",
      defaultMessage: [{
        "type": 0,
        "value": "Message us below or from your favourite app."
      }]
    }),
    lineChannelDescription: strictLocalize({
      id: "82iecS",
      defaultMessage: [{
        "type": 0,
        "value": "To talk to us using LINE, scan this QR code using the LINE app and send us a message."
      }]
    }),
    linkError: strictLocalize({
      id: "hlZfbl",
      defaultMessage: [{
        "type": 0,
        "value": "An error occurred when attempting to generate a link for this channel. Please try again. "
      }]
    }),
    linkChannelPageHeader: strictLocalize({
      id: "jSbwQA",
      defaultMessage: [{
        "type": 0,
        "value": "Sync your conversation"
      }]
    }),
    locationNotSupported: strictLocalize({
      id: "0cajDz",
      defaultMessage: [{
        "type": 0,
        "value": "Your browser does not support location services or it’s been disabled. Please type your location instead."
      }]
    }),
    locationSecurityRestriction: strictLocalize({
      id: "Q20rDu",
      defaultMessage: [{
        "type": 0,
        "value": "This website cannot access your location. Please type your location instead."
      }]
    }),
    locationSendingFailed: strictLocalize({
      id: "XWNAd3",
      defaultMessage: [{
        "type": 0,
        "value": "Could not send location"
      }]
    }),
    locationServicesDenied: strictLocalize({
      id: "EavZzB",
      defaultMessage: [{
        "type": 0,
        "value": "This website cannot access your location. Allow access in your settings or type your location instead."
      }]
    }),
    messageIndicatorTitlePlural: strictLocalize({
      id: "0+VvFB",
      defaultMessage: [{
        "type": 1,
        "value": "countNumber"
      }, {
        "type": 0,
        "value": " new messages"
      }]
    }, {
      countNumber: "{count}"
    }),
    messageIndicatorTitleSingular: strictLocalize({
      id: "CSCZoW",
      defaultMessage: [{
        "type": 1,
        "value": "countNumber"
      }, {
        "type": 0,
        "value": " new message"
      }]
    }, {
      countNumber: "{count}"
    }),
    messageRelativeTimeDay: strictLocalize({
      id: "xo/4Yu",
      defaultMessage: [{
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " d ago"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageRelativeTimeHour: strictLocalize({
      id: "bdg3Pr",
      defaultMessage: [{
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " h ago"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageRelativeTimeJustNow: strictLocalize({
      id: "72Tqww",
      defaultMessage: [{
        "type": 0,
        "value": "Just now"
      }]
    }),
    messageRelativeTimeMinute: strictLocalize({
      id: "SyJ9Zm",
      defaultMessage: [{
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " m ago"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageDelivered: strictLocalize({
      id: "I9y4Q1",
      defaultMessage: [{
        "type": 0,
        "value": "Delivered"
      }]
    }),
    messageSeen: strictLocalize({
      id: "2552ol",
      defaultMessage: [{
        "type": 0,
        "value": "Seen"
      }]
    }),
    messageSending: strictLocalize({
      id: "CzlJFq",
      defaultMessage: [{
        "type": 0,
        "value": "Sending..."
      }]
    }),
    messengerChannelDescription: strictLocalize({
      id: "EBuhyl",
      defaultMessage: [{
        "type": 0,
        "value": "Connect your Facebook Messenger account to be notified when you get a reply and continue the conversation on Facebook Messenger."
      }]
    }),
    newConversationButtonText: strictLocalize({
      id: "79XsJP",
      defaultMessage: [{
        "type": 0,
        "value": "New conversation"
      }]
    }),
    notificationSettingsChannelsDescription: strictLocalize({
      id: "nmmSL2",
      defaultMessage: [{
        "type": 0,
        "value": "Sync this conversation by connecting to your favourite messaging app to continue the conversation your way."
      }]
    }),
    notificationSettingsChannelsTitle: strictLocalize({
      id: "WuUmeV",
      defaultMessage: [{
        "type": 0,
        "value": "Other channels"
      }]
    }),
    notificationSettingsConnected: strictLocalize({
      id: "h3RKIm",
      defaultMessage: [{
        "type": 0,
        "value": "Connected"
      }]
    }),
    notificationSettingsConnectedAs: strictLocalize({
      id: "uepWZ4",
      defaultMessage: [{
        "type": 0,
        "value": "Connected as "
      }, {
        "type": 1,
        "value": "userPersonName"
      }]
    }, {
      userPersonName: "{username}"
    }),
    prechatCaptureGreetingText: strictLocalize({
      id: "JUJtTk",
      defaultMessage: [{
        "type": 0,
        "value": "Hi there. To start off, we’d like to know a little bit more about you:"
      }]
    }),
    prechatCaptureNameLabel: strictLocalize({
      id: "uLbNUt",
      defaultMessage: [{
        "type": 0,
        "value": "Your name"
      }]
    }),
    prechatCaptureNamePlaceholder: strictLocalize({
      id: "RwY05X",
      defaultMessage: [{
        "type": 0,
        "value": "Type your name..."
      }]
    }),
    prechatCaptureEmailLabel: strictLocalize({
      id: "kJy+AB",
      defaultMessage: [{
        "type": 0,
        "value": "Email"
      }]
    }),
    prechatCaptureEmailPlaceholder: strictLocalize({
      id: "bHoo9p",
      defaultMessage: [{
        "type": 0,
        "value": "name@company.com"
      }]
    }),
    prechatCaptureConfirmationText: strictLocalize({
      id: "MxlmAH",
      defaultMessage: [{
        "type": 0,
        "value": "Thanks for that! What can we help you with?"
      }]
    }),
    prechatCaptureMailgunLinkingConfirmation: strictLocalize({
      id: "qhC82s",
      defaultMessage: [{
        "type": 0,
        "value": "You’ll be notified here and by email at "
      }, {
        "type": 1,
        "value": "emailEmailAddress"
      }, {
        "type": 0,
        "value": " once we reply."
      }]
    }, {
      emailEmailAddress: "{email}"
    }),
    sendButtonText: strictLocalize({
      id: "xLWTdR",
      defaultMessage: [{
        "type": 0,
        "value": "Send"
      }]
    }),
    settingsHeaderText: strictLocalize({
      id: "0QV6z2",
      defaultMessage: [{
        "type": 0,
        "value": "Settings"
      }]
    }),
    shareLocation: strictLocalize({
      id: "rvirM2",
      defaultMessage: [{
        "type": 0,
        "value": "Location"
      }]
    }),
    smsBadRequestError: strictLocalize({
      id: "d5wiZz",
      defaultMessage: [{
        "type": 0,
        "value": "We were unable to communicate with this number. Try again or use a different one."
      }]
    }),
    smsCancel: strictLocalize({
      id: "gHLemI",
      defaultMessage: [{
        "type": 0,
        "value": "Cancel"
      }]
    }),
    smsChangeNumber: strictLocalize({
      id: "T9LQOH",
      defaultMessage: [{
        "type": 0,
        "value": "Change my number"
      }]
    }),
    smsChannelDescription: strictLocalize({
      id: "E9/0ru",
      defaultMessage: [{
        "type": 0,
        "value": "Connect your SMS number to be notified when you get a reply and continue the conversation over SMS."
      }]
    }),
    smsChannelPendingDescription: strictLocalize({
      id: "spQ3hG",
      defaultMessage: [{
        "type": 0,
        "value": "Check your messages on "
      }, {
        "type": 1,
        "value": "phoneNumber"
      }, {
        "type": 0,
        "value": " to confirm your phone number."
      }]
    }, {
      phoneNumber: "{number}"
    }),
    smsContinue: strictLocalize({
      id: "xLWTdR",
      defaultMessage: [{
        "type": 0,
        "value": "Send"
      }]
    }),
    smsInvalidNumberError: strictLocalize({
      id: "QaDAmJ",
      defaultMessage: [{
        "type": 0,
        "value": "Please submit a valid phone number."
      }]
    }),
    smsLinkCancelled: strictLocalize({
      id: "q4dN8U",
      defaultMessage: [{
        "type": 0,
        "value": "Link to "
      }, {
        "type": 1,
        "value": "appUserNumber"
      }, {
        "type": 0,
        "value": " was cancelled."
      }]
    }, {
      appUserNumber: "{appUserNumber}"
    }),
    smsLinkPending: strictLocalize({
      id: "I1RY7U",
      defaultMessage: [{
        "type": 0,
        "value": "Pending"
      }]
    }),
    smsPingChannelError: strictLocalize({
      id: "UBAoB1",
      defaultMessage: [{
        "type": 0,
        "value": "There was an error sending a message to your number."
      }]
    }),
    smsSendText: strictLocalize({
      id: "x7rAeU",
      defaultMessage: [{
        "type": 0,
        "value": "Send me a text"
      }]
    }),
    smsStartTexting: strictLocalize({
      id: "TGJUj4",
      defaultMessage: [{
        "type": 0,
        "value": "Start texting"
      }]
    }),
    smsTooManyRequestsError: strictLocalize({
      id: "jVSLkV",
      defaultMessage: [{
        "type": 0,
        "value": "A connection for that number was requested recently. Please try again in "
      }, {
        "type": 1,
        "value": "minutesTime"
      }, {
        "type": 0,
        "value": " minutes."
      }]
    }, {
      minutesTime: "{minutes}"
    }),
    smsTooManyRequestsOneMinuteError: strictLocalize({
      id: "0XliGQ",
      defaultMessage: [{
        "type": 0,
        "value": "A connection for that number was requested recently. Please try again in 1 minute."
      }]
    }),
    smsUnhandledError: strictLocalize({
      id: "W1a+Iy",
      defaultMessage: [{
        "type": 0,
        "value": "Something went wrong. Please try again. "
      }]
    }),
    syncConversation: strictLocalize({
      id: "B2qj3w",
      defaultMessage: [{
        "type": 0,
        "value": "Sync conversation"
      }]
    }),
    tapToRetry: strictLocalize({
      id: "P7ZSoc",
      defaultMessage: [{
        "type": 0,
        "value": "Message not delivered. Tap to retry."
      }]
    }),
    tapToRetryForm: strictLocalize({
      id: "QqMyCB",
      defaultMessage: [{
        "type": 0,
        "value": "Form not submitted. Tap anywhere on the form to retry."
      }]
    }),
    telegramChannelDescription: strictLocalize({
      id: "Rtuws+",
      defaultMessage: [{
        "type": 0,
        "value": "Connect your Telegram account to be notified when you get a reply and continue the conversation on Telegram"
      }]
    }),
    unsupportedMessageType: strictLocalize({
      id: "E9qCDM",
      defaultMessage: [{
        "type": 0,
        "value": "Unsupported message type."
      }]
    }),
    unsupportedActionType: strictLocalize({
      id: "mMB611",
      defaultMessage: [{
        "type": 0,
        "value": "Unsupported action type."
      }]
    }),
    uploadDocument: strictLocalize({
      id: "hdlOID",
      defaultMessage: [{
        "type": 0,
        "value": "File"
      }]
    }),
    uploadInvalidError: strictLocalize({
      id: "gn05y6",
      defaultMessage: [{
        "type": 0,
        "value": "Invalid file"
      }]
    }),
    uploadPhoto: strictLocalize({
      id: "OAzZGu",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    }),
    uploadVirusError: strictLocalize({
      id: "x5EOZK",
      defaultMessage: [{
        "type": 0,
        "value": "A virus was detected in your file and it has been rejected"
      }]
    }),
    viberChannelDescription: strictLocalize({
      id: "Z3K0oO",
      defaultMessage: [{
        "type": 0,
        "value": "Connect your Viber account to be notified when you get a reply and continue the conversation on Viber. To get started, scan the QR code using the Viber app."
      }]
    }),
    viberChannelDescriptionMobile: strictLocalize({
      id: "xuYgMg",
      defaultMessage: [{
        "type": 0,
        "value": "Connect your Viber account to be notified when you get a reply and continue the conversation on Viber. To get started, install the Viber app and tap Connect."
      }]
    }),
    viberQRCodeError: strictLocalize({
      id: "AYSCMJ",
      defaultMessage: [{
        "type": 0,
        "value": "An error occurred while retrieving your Viber QR code. Please try again. "
      }]
    }),
    wechatChannelDescription: strictLocalize({
      id: "qIPntD",
      defaultMessage: [{
        "type": 0,
        "value": "Connect your WeChat account to be notified when you get a reply and continue the conversation on WeChat. To get started, scan this QR code using the WeChat app."
      }]
    }),
    wechatChannelDescriptionMobile: strictLocalize({
      id: "4p4TBs",
      defaultMessage: [{
        "type": 0,
        "value": "Connect your WeChat account to be notified when you get a reply and continue the conversation on WeChat. To get started, save this QR code image and upload it in the QR code scanner."
      }]
    }),
    wechatQRCodeError: strictLocalize({
      id: "TdTat4",
      defaultMessage: [{
        "type": 0,
        "value": "An error occurred while retrieving your WeChat QR code. Please try again. "
      }]
    }),
    whatsappChannelDescriptionDesktop: strictLocalize({
      id: "tlAllf",
      defaultMessage: [{
        "type": 0,
        "value": "Sync your account to WhatsApp by scanning the QR code or clicking the link below. Then, send the pre-populated message to validate the sync request. (Your code: "
      }, {
        "type": 1,
        "value": "codeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      codeNumber: "{code}"
    }),
    whatsappChannelDescriptionMobile: strictLocalize({
      id: "/YEwfr",
      defaultMessage: [{
        "type": 0,
        "value": "Sync your account to WhatsApp by clicking the link below. Then, send the pre-populated message to validate the sync request. (Your code: "
      }, {
        "type": 1,
        "value": "codeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      codeNumber: "{code}"
    }),
    whatsappLinkingError: strictLocalize({
      id: "49auTS",
      defaultMessage: [{
        "type": 0,
        "value": "An error occurred while retrieving your WhatsApp linking information. Please try again. "
      }]
    })
  };
};